export const createElement = (tagName, attributes, events) => {
	const element = document.createElement(tagName);
	if (attributes) {
		Object.keys(attributes).forEach(key => {
			element[key] = attributes[key];
		});
	}
	if (events) {
		Object.keys(events).forEach(key => element.addEventListener(key, events[key]));
	}
	return element;
};

export const createAndAppendElement = (parent, ...args) =>
	parent.appendChild(createElement(...args));
